export interface Client {
  id: string
  name: string
  address: {
    street: string
    city: string
    postalCode: string
    region: string
    coordinates: {
      lat: number
      lng: number
    }
  }
  contractType: 'forfait' | 'remorque' | 'prestation'
  priority: 'high' | 'medium' | 'low'
  services: string[]
  contact: {
    name: string
    phone: string
    email: string
  }
  snowRemovalDuration: number // Duration in minutes
}
export const clients: Client[] = [
  {
    id: 'CLT-001',
    name: 'Centre Commercial Laurier Québec',
    address: {
      street: '2700 Boulevard Laurier',
      city: 'Québec',
      postalCode: 'G1V 2L8',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7719, lng: -71.2845 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage'],
    contact: {
      name: 'Marie Tremblay',
      phone: '418-555-0101',
      email: 'marie.tremblay@laurier.com',
    },
    snowRemovalDuration: 120,
  },
  {
    id: 'CLT-002',
    name: "Hôpital de l'Enfant-Jésus",
    address: {
      street: '1401 18e Rue',
      city: 'Québec',
      postalCode: 'G1J 1Z4',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.8352, lng: -71.2456 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage', 'urgence'],
    contact: {
      name: 'Dr. Jean Bouchard',
      phone: '418-555-0102',
      email: 'j.bouchard@enfantjesus.qc.ca',
    },
    snowRemovalDuration: 90,
  },
  {
    id: 'CLT-003',
    name: 'Université Laval',
    address: {
      street: "2325 Rue de l'Université",
      city: 'Québec',
      postalCode: 'G1V 0A6',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7808, lng: -71.2754 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage'],
    contact: {
      name: 'Pierre Gagnon',
      phone: '418-555-0103',
      email: 'pierre.gagnon@ulaval.ca',
    },
    snowRemovalDuration: 180,
  },
  {
    id: 'CLT-004',
    name: 'Galeries de la Capitale',
    address: {
      street: '5401 Boulevard des Galeries',
      city: 'Québec',
      postalCode: 'G2K 1N4',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.8475, lng: -71.3015 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage'],
    contact: {
      name: 'Sophie Leblanc',
      phone: '418-555-0104',
      email: 'sleblanc@galeriescapitale.com',
    },
    snowRemovalDuration: 150,
  },
  {
    id: 'CLT-005',
    name: 'Complexe Imax Lévis',
    address: {
      street: '5800 Rue J.-B.-Michaud',
      city: 'Lévis',
      postalCode: 'G6V 0B2',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7875, lng: -71.1698 },
    },
    contractType: 'remorque',
    priority: 'medium',
    services: ['déneigement'],
    contact: {
      name: 'Marc Côté',
      phone: '418-555-0105',
      email: 'mcote@imax-levis.com',
    },
    snowRemovalDuration: 75,
  },
  {
    id: 'CLT-006',
    name: 'Parc Technologique du Québec Métropolitain',
    address: {
      street: "1020 Route de l'Église",
      city: 'Québec',
      postalCode: 'G1V 3V9',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7695, lng: -71.2912 },
    },
    contractType: 'forfait',
    priority: 'medium',
    services: ['déneigement', 'déglaçage'],
    contact: {
      name: 'Isabelle Roy',
      phone: '418-555-0106',
      email: 'iroy@parctech.qc.ca',
    },
    snowRemovalDuration: 60,
  },
  {
    id: 'CLT-007',
    name: 'Centre Vidéotron',
    address: {
      street: '250 Boulevard Wilfrid-Hamel',
      city: 'Québec',
      postalCode: 'G1L 5A7',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.8298, lng: -71.2598 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage', 'urgence'],
    contact: {
      name: 'François Dubois',
      phone: '418-555-0107',
      email: 'fdubois@centrevideotron.ca',
    },
    snowRemovalDuration: 100,
  },
  {
    id: 'CLT-008',
    name: 'Aéroport International Jean-Lesage',
    address: {
      street: '505 Rue Principale',
      city: 'Québec',
      postalCode: 'G2G 0J4',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7911, lng: -71.3933 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage', 'urgence', 'pistes'],
    contact: {
      name: 'Caroline Bergeron',
      phone: '418-555-0108',
      email: 'cbergeron@aeroportquebec.com',
    },
    snowRemovalDuration: 240,
  },
  {
    id: 'CLT-009',
    name: 'Résidence Les Jardins du Haut-Saint-Laurent',
    address: {
      street: '1515 Rue Frank-Carrel',
      city: 'Québec',
      postalCode: 'G1N 2E5',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.8512, lng: -71.2398 },
    },
    contractType: 'prestation',
    priority: 'medium',
    services: ['déneigement'],
    contact: {
      name: 'Lucie Fortin',
      phone: '418-555-0109',
      email: 'lfortin@jardins-hsl.com',
    },
    snowRemovalDuration: 45,
  },
  {
    id: 'CLT-010',
    name: 'Place de la Cité',
    address: {
      street: '2600 Boulevard Laurier',
      city: 'Québec',
      postalCode: 'G1V 4T3',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7701, lng: -71.2867 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage'],
    contact: {
      name: 'André Lavoie',
      phone: '418-555-0110',
      email: 'alavoie@placedelacite.com',
    },
    snowRemovalDuration: 110,
  },
  {
    id: 'CLT-011',
    name: 'CHUL - Centre Hospitalier Universitaire',
    address: {
      street: '2705 Boulevard Laurier',
      city: 'Québec',
      postalCode: 'G1V 4G2',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7723, lng: -71.2801 },
    },
    contractType: 'forfait',
    priority: 'high',
    services: ['déneigement', 'déglaçage', 'urgence'],
    contact: {
      name: 'Dr. Sylvie Moreau',
      phone: '418-555-0111',
      email: 'smoreau@chul.qc.ca',
    },
    snowRemovalDuration: 95,
  },
  {
    id: 'CLT-012',
    name: 'Complexe Sportif de Sainte-Foy',
    address: {
      street: '930 Avenue Roland-Beaudin',
      city: 'Québec',
      postalCode: 'G1V 1B3',
      region: 'Capitale-Nationale',
      coordinates: { lat: 46.7645, lng: -71.2923 },
    },
    contractType: 'remorque',
    priority: 'medium',
    services: ['déneigement', 'déglaçage'],
    contact: {
      name: 'Robert Pelletier',
      phone: '418-555-0112',
      email: 'rpelletier@complexesf.com',
    },
    snowRemovalDuration: 70,
  },
]
